import { cssClasses } from 'pkg/css/utils';

import * as css from './styles.css';

interface BodyProps extends React.HTMLAttributes<HTMLDivElement> {
	spaciousBody?: boolean;
	narrowBody?: boolean;
	noSpacing?: boolean;
	flex?: boolean;
}

export function Body({
	spaciousBody,
	narrowBody,
	noSpacing,
	flex,
	children,
	className,
	...rest
}: BodyProps) {
	return (
		<div
			className={cssClasses(
				css.body,
				narrowBody && css.narrowBody,
				spaciousBody && css.spaciousBody,
				noSpacing && css.noSpacing,
				flex && css.flex,
				className
			)}
			{...rest}>
			{children}
		</div>
	);
}
